







































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import AutocompleteUser from './components/AutocompleteUser.vue';
import AddUser from './components/AddUser.vue';

import ThemeDefault from '@/themes/default/theme_default';
import ThemeKirjaclub from '@/themes/kirjaclub/theme_kirjaclub';

@Component({
  components: {
    AddUser,
    AutocompleteUser,
  }
})
export default class App extends Vue {
  /*tslint:disable max-line-length*/
  drawer = null;
  selectedUser: IUser | null = null;
  carIcon: string = 'mdi-car-multiple';
  showSelectShareHasMembers: boolean = false;
  appBarTitle: string = 'Regit';

  get isAdmin() {
    return this.$store.getters['auth/isAdmin'];
  }

  get userId() {
    if (this.$store.state.auth.profile) {
      return this.$store.state.auth.profile.id;
    }
    return 0;
  }

  get isLoading() {
    return this.$store.state.app.loading;
  }

  get shareHasMembers() {
    return this.$store.getters['app/shareHasMembers'];
  }

  get menuItems() {
    const userDetailsText = this.shareHasMembers ? 'Omat tiedot' : 'Käyttäjätiedot';
    const items = [
      { label: 'Ajankohtaista', icon: 'mdi-text-box', to: '/News', show: this.$store.getters['auth/isAuthenticated'] && this.shareHasMembers },
      { label: 'Tiedostot', icon: 'mdi-file-download', to: '/SharedDocuments', show: this.$store.getters['auth/isAuthenticated'] && this.shareHasMembers },
      { label: 'Jäsenrekisteri', icon: 'mdi-card-account-details', to: '/Members', show: this.isAdmin },
      { label: userDetailsText, icon: 'mdi-card-account-details', to: `/UserDetails/${this.userId}`, show: !this.isAdmin && this.$store.getters['auth/isAuthenticated'] },
      { label: 'Osakkeet', icon: 'mdi-file', to: '/Shares', show: this.isAdmin },
      { label: 'Osakkaat', icon: 'mdi-folder-account', to: '/Shareholders', show: this.isAdmin },
      { label: 'Palvelusopimukset', icon: 'mdi-text-box-multiple', to: '/Contracts', show: this.isAdmin && !this.shareHasMembers },
      { label: 'Kalustoluettelo', icon: 'mdi-car-multiple', to: '/Cars', show: this.isAdmin && !this.shareHasMembers },
      { label: 'Jäsenprofiilit', icon: 'mdi-account-box-multiple', to: '/Profiles', show: this.$store.getters['auth/isAuthenticated'] && this.shareHasMembers },
      { label: 'Kirjaudu ulos', icon: 'mdi-logout-variant', to: '/Logout', show: true },
    ];
    return items.filter(i => i.show);
  }

  get initialized() {
    return this.$store.state.app.initialized;
  }
  get users() {
    const users = this.$store.getters['admin/allUsers'];
    return users;
  }

  get snackBar() {
    return this.$store.state.app.snackBar;
  }

  searchFilter(item: IUser, query: string, itemText: string) {
    return ['name', 'email', 'phoneNumber'].some(s => {
      const propVal = (item as any)[s];
      return (
        typeof propVal === 'string' && propVal.toLowerCase().indexOf(query.toLowerCase()) >= 0
      );
    });
  }

  @Watch('selectedUser')
  userSelected() {
    if (this.selectedUser) {
      const id = this.selectedUser.id;
      this.$router.push({ path: `/UserDetails/${id}` });
      this.$nextTick(() =>  this.selectedUser = null);
    }
  }

  // Quick hack to implement themes
  @Watch('shareHasMembers', { immediate: true }) onShareHasMembersChanged() {
    this.shareHasMembers
      ? Object.assign(this.$vuetify.theme.themes.light, new ThemeKirjaclub().vuetifyTheme)
      : Object.assign(this.$vuetify.theme.themes.light, new ThemeDefault().vuetifyTheme);

    document.title =  this.shareHasMembers ?  'KC Intra' : 'Regit';
    this.appBarTitle = this.shareHasMembers ? 'Intra' : this.appBarTitle;
  }

  changeShareHasMembers() {
    this.$store.commit('app/setShareHasMembers', !this.shareHasMembers);
  }

  mounted() {
    this.showSelectShareHasMembers =  process.env.NODE_ENV === 'development' || document.location.host.indexOf('localhost') > -1;
  }
}
